import { Types } from "@grandvisionhq/graphql";
const mapInsuranceLineItem = ({
  sku,
  quantity,
  typeDetails
}) => ({
  sku,
  quantity: quantity ?? 1,
  lineItemType: Types.LineItemType.INSURANCE,
  typeDetails
});
export {
  mapInsuranceLineItem
};
//# sourceMappingURL=insurance.js.map
